import { Controller } from "@hotwired/stimulus"
import { smartMatch } from "../../utils/smart_search"

// Formulaire de génération des emplois du temps (GO4SDOC) : affiche le
// panneau de sélection du périmètre choisi (école, niveaux, classes,
// enseignants, service des professeurs, salles), « Tout cocher » et la
// recherche dans les listes. Chaque panneau a ses propres champs
// (targets[<périmètre>][]) : le serveur ne lit que ceux du périmètre choisi.
//
// Connects to data-controller="schedule-generation"
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelector('input[name="generate_schedule[generation_scope]"]:checked')
    const scope = checked ? checked.value : null
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.scope !== scope
    })
  }

  toggleAll(event) {
    const panel = event.target.closest('[data-schedule-generation-target="panel"]')
    if (!panel) return

    panel.querySelectorAll("input[data-target-item]").forEach((checkbox) => {
      const item = checkbox.closest("[data-filter-item]")
      if (!item || item.style.display !== "none") checkbox.checked = event.target.checked
    })
  }

  filter(event) {
    const panel = event.target.closest('[data-schedule-generation-target="panel"]')
    if (!panel) return

    const query = event.target.value
    panel.querySelectorAll("[data-filter-item]").forEach((item) => {
      // style plutôt que hidden : la classe flex de l'étiquette l'emporterait.
      item.style.display = smartMatch(item.dataset.filterItem, query) ? "" : "none"
    })
  }
}
